export default "__VITE_ASSET__2a99e789__"